import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 5B2EA1B8-10D5-4770-812F-3CC3ADF33B59
 * name train-car-gondola-full
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/train-car-gondola-full.svg
 * tags
 * - Transportation + Other 
 */
export const TrainCarGondolaFullIcon = createSvgIcon(<><path d="M21 10C19.04 8.19 15.74 7 12 7S4.96 8.19 3 10H1V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V10H21M21 15H19V13H17V15H15V13H13V15H11V13H9V15H7V13H5V15H3V12H21V15Z" /></>, 'TrainCarGondolaFullIcon');
export default TrainCarGondolaFullIcon